module.exports = __webpack_public_path__ + "img/audioDefault.44aba3e8.png";